import ajax from '../util/ajax'
import { backendUrl } from '../util/endpointConfig'

export interface IGeolocationResult {
  lat: number
  lon: number
}

export default async function geoLocation({
  placeId,
  sessionToken,
}: {
  placeId: string
  sessionToken: string
}): Promise<IGeolocationResult> {
  const { ans } = await ajax<IGeolocationResult>(
    'GET',
    `${backendUrl}services/geoLocation/${encodeURIComponent(placeId)}?sessionToken=${sessionToken}`
  )
  return ans
}
